import { Component, Input } from "@angular/core";
import { ILoadingConfig } from "ngx-loading/src/ngx-loading.config";

@Component({
  selector: "shared-loading",
  templateUrl: "./loading.component.html"
})
export class LoadingComponent {

  config: ILoadingConfig = {
    backdropBackgroundColour: "rgba(0,0,0,0)",
    primaryColour: "#00acb0",
    secondaryColour: "#00acb0",
    tertiaryColour: "#00acb0"
  };

  @Input() public isLoading: boolean;
}
